// extracted by mini-css-extract-plugin
export default {"link":"LC-z","disabled":"MC-z"};